
export const parseOptions = (options?: string): string[] => {
    if (!options) return [];
    return options.split('\n');
};

export const serializeOptions = (options: string[]): string => {
    return options.join('\n');
};


export const getNonEmptyOptions = (options?: string): string[] => {
    return parseOptions(options).filter(opt => opt.trim() !== '');
};

export const addEmptyOption = (options: string[]): string[] => {
    return [...options, ''];
};

export const removeOptionAtIndex = (options: string[], optionIndex: number): string[] => {
    return options.filter((_, index) => index !== optionIndex);
};

export const updateOptionAtIndex = (options: string[], optionIndex: number, value: string): string[] => {
    const newOptions = [...options];
    newOptions[optionIndex] = value;
    return newOptions;
};

export const cleanupEmptyOptions = (options: string[]): string[] => {
    const cleanedOptions = options.filter(opt => opt.trim());
    return cleanedOptions.length === 0 ? [''] : cleanedOptions;
};

